/* CUBE STORE - un tasto solo nella colonna, quando la taglia e' scelta

   REGOLA: appena si accende un nostro tasto - PRENOTA o PROCEDI
   ALL'ACQUISTO - il pulsante del tema sparisce dalla colonna. Torna
   quando la taglia non e' ancora scelta, quando e' esaurita, e dentro
   la finestra, dove e' lui a concludere l'ordine.

   PERCHE'
   Scelta la taglia, il cliente si trovava davanti due pulsanti sovrapposti
   che portano a due posti diversi: il nostro raccoglie la dichiarazione
   di pagamento, quello del tema aggiunge e basta. Non e' una scelta fra
   due strade, e' la stessa strada con e senza una tappa che ci serve -
   e messi uno sopra l'altro il piu' vicino vince, cioe' quello
   sbagliato. Prima della scelta invece resta: e' il pulsante che fa
   comparire "Scegli la taglia per continuare" (cube-taglie.js), quindi
   li' sta facendo il suo lavoro.

   PERCHE' NON STA IN cube-azioni.js
   Ci starebbe: la sua nascondiAcquistoDuranteLaPrenotazione() e' la
   stessa regola, applicata alla sola prenotazione. Ma quel file pesa
   17 KB e il connettore non lo riscrive - va oltre il tetto di una
   singola chiamata. QUANDO SI TOCCA UNA DELLE DUE SI GUARDI L'ALTRA:
   sono un ragionamento solo diviso in due per un limite di attrezzo,
   non per disegno. Da riunire alla prima occasione buona.

   PERCHE' UNA CLASSE E NON hidden
   L'attributo hidden su quel blocco lo governa cube-azioni.js e lo
   riscrive a ogni modifica del DOM: contenderglielo voleva dire due
   script che si rincorrono all'infinito, ognuno che rifa' la modifica
   che risveglia l'altro. Con una classe nostra non si pestano i piedi.
   Il display: none sta in cube-azioni-piede.css, insieme alle altre
   regole di visibilita' di questo blocco.

   SE NON SI SA, IL PULSANTE RESTA
   Si nasconde solo su uno stato certo - prenotabile o pronta. Con la
   tabella ancora da disegnare cubeStatoTaglia risponde null, e li' un
   pulsante di troppo e' molto meno grave di una pagina da cui non si
   puo' comprare. */
(function () {
  var VIA = 'cube-acquisto-via';

  function statoNoto() {
    if (typeof window.cubeStatoTaglia !== 'function') return false;
    var s = window.cubeStatoTaglia();
    return s === 'pronta' || s === 'prenotabile';
  }

  function aggiorna() {
    var blocco = document.querySelector('.product-form-buttons');
    if (!blocco) return;

    var fila = document.querySelector('.cube-azioni');
    var acceso = !!(fila && !fila.hidden && fila.querySelector('.cube-azioni__tasto:not([hidden])'));
    var dentroLaFinestra = !!blocco.closest('.cube-modale__piede');

    blocco.classList.toggle(VIA, acceso && statoNoto() && !dentroLaFinestra);
  }

  var inCoda = false;
  function programma() {
    if (inCoda) return;
    inCoda = true;
    requestAnimationFrame(function () {
      inCoda = false;
      aggiorna();
    });
  }

  function init() {
    aggiorna();
    if (!document.body) return;
    new MutationObserver(programma).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
